import { render, staticRenderFns } from "./OnboardingFinal.vue?vue&type=template&id=e118b52c&scoped=true"
import script from "./OnboardingFinal.vue?vue&type=script&lang=js"
export * from "./OnboardingFinal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingFinal.vue?vue&type=style&index=0&id=e118b52c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e118b52c",
  null
  
)

export default component.exports